import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import database from './database'
import { BACKGROUND_COLOR } from './utils/backgroundType'
import store from './store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '',
            redirect: '/login'
        },
        {
            path: '*',
            redirect: '/login'
        },
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login/:uname',
            component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
        },
        {
            path: '/onboarding',
            name: 'onboarding',
            component: () => import(/* webpackChunkName: "onboarding" */ './views/Onboarding.vue'),
            meta: {
                background: BACKGROUND_COLOR.ONBOARDING_GUIDE,
                requiresAuth: true
            }
        },
        {
            path: '/onboarding-guide',
            name: 'onboardingguide',
            component: () => import(/* webpackChunkName: "onboardingguide" */ './views/OnboardingGuide.vue'),
            meta: {
                background: BACKGROUND_COLOR.ONBOARDING_GUIDE,
                requiresAuth: true
            }
        },
        {
            path: '/home',
            name: 'home',
            component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pitanje/:id',
            name: 'pitanje',
            component: () => import(/* webpackChunkName: "pitanje" */ './views/Pitanje.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/prijava-pitanja',
            name: 'prijava',
            component: () => import(/* webpackChunkName: "prijavapitanja" */ './views/PrijavaPitanja.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/rezultati',
            name: 'rezultati',
            component: () => import(/* webpackChunkName: "rezultati" */ './views/Rezultati.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/korisnik/:uid',
            name: 'korisnik',
            component: () => import(/* webpackChunkName: "korisnik" */ './views/Korisnik.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/moje-lige',
            name: 'mojelige',
            component: () => import(/* webpackChunkName: "mojelige" */ './views/MojeLige.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/moje-grupe',
            name: 'mojegrupe',
            component: () => import(/* webpackChunkName: "mojegrupe" */ './views/MojeGrupe.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/natjecatelji/:id',
            name: 'natjecatelji',
            component: () => import(/* webpackChunkName: "natjecatelji" */ './views/MojeLigeNatjecatelji.vue'),
            meta: {
                background: BACKGROUND_COLOR.BLANK,
                requiresAuth: true
            }
        },
        {
            path: '/grupacija/:id',
            name: 'grupacija',
            component: () => import(/* webpackChunkName: "natjecatelji" */ './views/MojeGrupeNatjecatelji.vue'),
            meta: {
                background: BACKGROUND_COLOR.BLANK,
                requiresAuth: true
            }
        },
        {
            path: '/kreiraj-ligu',
            name: 'kreirajligu',
            component: () => import(/* webpackChunkName: "kreirajligu" */ './views/KreirajLigu.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/kreiraj-grupu',
            name: 'kreirajgrupu',
            component: () => import(/* webpackChunkName: "kreirajgrupu" */ './views/KreirajGrupu.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/liga/:id',
            name: 'prijavauligu',
            component: () => import(/* webpackChunkName: "pitanje" */ './views/PrijavaULigu.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/grupa/:id',
            name: 'prijavaugrupu',
            component: () => import(/* webpackChunkName: "grupa" */ './views/PrijavaUGrupu.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pravila',
            name: 'pravila',
            component: () => import(/* webpackChunkName: "pravila" */ './views/Pravila.vue'),
            meta: {
                background: BACKGROUND_COLOR.BLANK,
                requiresAuth: true
            }
        },
        {
            path: '/search/:value',
            name: 'search',
            component: () => import(/* webpackChunkName: "search" */ './views/Search.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/probno-pitanje/:id',
            name: 'probno-pitanje',
            component: () => import(/* webpackChunkName: "probnopitanje" */ './views/ProbnoPitanje.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/probna-prijava-pitanja',
            name: 'probna-prijava-pitanja',
            component: () => import(/* webpackChunkName: "probnaprijavapitanja" */ './views/ProbnaPrijavaPitanja.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/404',
            component: NotFound
            // },
            // {
            //   path: '*',
            //   redirect: '/404'
        },
        {
            path: '/rezultati/korisnik/:uid/:quizId',
            name: 'rezultatisingle',
            component: () => import(/* webpackChunkName: "rezultatisingle" */ './views/RezultatiSingle.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/uredaj-obavijest',
            name: 'uredaj-obavijest',
            component: () => import(/* webpackChunkName: "uredajobavijest" */ './views/UredajObavijest.vue'),
            meta: {
                requiresAuth: true
            }
        }
    ]
})
/**
 * handle auth
 * user is redirected to login screen if not logged in
 */
router.beforeEach(async (to, from, next) => {
    if (to.name === 'login/:uname') {
        if (Object.keys(to.query).length !== 0) {
            await firebase.auth().signOut()
        }
    }
    try {
        await database.metadata.getMetadata()
        if (to.name !== 'uredaj-obavijest') {
            database.metadata.setActiveDeviceToken()
        }
    } catch (error) {
        console.error(error)
    }
    const currentUser = firebase.auth().currentUser
    const auth = to.matched.some(record => record.meta.requiresAuth)
    if (auth && currentUser) {
        store.dispatch('authorize')
    }
    if (!currentUser && auth) {
        const excludePages = [
            'onboarding',
            'onboardingguide',
            'probno-pitanje',
            'pravila'
        ]
        console.log(to.name)
        console.log(!excludePages.includes(to.name))
        if (excludePages.includes(to.name)) {
            next()
        } else {
            next('/login')
        }
    } else if (!auth && currentUser) {
        next('/home')
    } else next()
})

try {
    router.afterEach((to, from) => {
        try {
            // this is defined in the index.html file
            // eslint-disable-next-line no-undef
            gtag('config', 'UA-4274980-21', { 'page_path': to.path })
        } catch (error) {
            console.error(error)
        }
    })
} catch (error) {
    console.error(error)
}

export default router
